var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZh = function SvgZh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#E53B35",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FE0",
    d: "m6.6 4.5.808 2.488h2.616L7.908 8.525l.808 2.487L6.6 9.476l-2.116 1.537.808-2.487-2.116-1.537h2.616zM11.4 3l.269.83h.871l-.705.512.27.829-.706-.513-.705.513.27-.83-.706-.512h.872zM13.8 5.4l.269.83h.872l-.706.512.27.829-.705-.513-.706.513.27-.83-.706-.512h.872zM13.8 8.7l.269.829h.872l-.706.512.27.83-.705-.513-.706.512.27-.829-.706-.512h.872zM11.4 11.1l.269.829h.871l-.705.512.27.83-.706-.513-.705.512.27-.829-.706-.512h.872z"
  })));
};
export default SvgZh;